<template>
  <footer class="github-footer">
    <a class="footer-link" href=""></a>
  </footer>
</template>
<script>

export default {
  name: 'foot',
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/foot.vue